var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup224(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 93,
    viewBox: "0 0 102 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#DEF6FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 60.5C69.5 59.837 69.2366 59.2011 68.7678 58.7322C68.2989 58.2634 67.663 58 67 58H57C56.337 58 55.7011 58.2634 55.2322 58.7322C54.7634 59.2011 54.5 59.837 54.5 60.5C54.5 61.163 54.7634 61.7989 55.2322 62.2678C55.7011 62.7366 56.337 63 57 63H67C67.663 63 68.2989 62.7366 68.7678 62.2678C69.2366 61.7989 69.5 61.163 69.5 60.5Z",
    fill: "#322FB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1666 64.25H57.8334C57.2485 64.3572 56.7198 64.6661 56.3391 65.1229C55.9585 65.5796 55.75 66.1554 55.75 66.75C55.75 67.3446 55.9585 67.9204 56.3391 68.3771C56.7198 68.8339 57.2485 69.1428 57.8334 69.25H66.1666C66.7515 69.1428 67.2802 68.8339 67.6609 68.3771C68.0415 67.9204 68.25 67.3446 68.25 66.75C68.25 66.1554 68.0415 65.5796 67.6609 65.1229C67.2802 64.6661 66.7515 64.3572 66.1666 64.25Z",
    fill: "#322FB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 79.6315V90.5H98.25V79.8021C98.25 74.6647 94.0853 73 88.9479 73H75.75L62 85.5L47 73H34.8815C29.8383 73 25.75 74.5883 25.75 79.6315Z",
    fill: "#322FB3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.25 71.75H60.75V78H63.25V71.75Z",
    fill: "#322FB3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.25 71.75H65.75V75.5H68.25V71.75Z",
    fill: "#322FB3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.25 71.75H55.75V75.5H58.25V71.75Z",
    fill: "#322FB3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3091 15.6318L35.1909 17.8682L42.6909 21.6182L43.8091 19.3818L36.3091 15.6318Z",
    fill: "#322FB3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.855 16.1139L79.8997 18.7653L80.6898 21.1361L88.6451 18.4848L87.855 16.1139Z",
    fill: "#322FB3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 31.75H29.5V34.25H38.25V31.75Z",
    fill: "#322FB3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 31.75H85.75V34.25H94.5V31.75Z",
    fill: "#322FB3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4409 48.1318L33.9409 51.8818L35.0591 54.1182L42.5591 50.3682L41.4409 48.1318Z",
    fill: "#322FB3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5591 48.1318L81.4409 50.3682L88.9409 54.1182L90.0591 51.8818L82.5591 48.1318Z",
    fill: "#322FB3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 52.6875L56.1125 56.9125H67.8875L69.5 52.6875C73.448 50.9644 76.6824 47.9345 78.6591 44.1072C80.6359 40.28 81.2346 35.8888 80.3545 31.672C79.4744 27.4552 77.1692 23.6701 73.8266 20.9531C70.4839 18.236 66.3077 16.7528 62 16.7528C57.6924 16.7528 53.5161 18.236 50.1735 20.9531C46.8308 23.6701 44.5256 27.4552 43.6455 31.672C42.7654 35.8888 43.3641 40.28 45.3409 44.1072C47.3177 47.9345 50.552 50.9644 54.5 52.6875ZM63.25 42.6337C63.25 42.4696 63.2824 42.307 63.3452 42.1554C63.408 42.0037 63.5002 41.866 63.6163 41.75L69.8663 35.5L71.6338 37.2675L65.75 43.1513V55.1337H63.25V42.6337ZM54.1338 35.5L60.3838 41.75C60.4999 41.866 60.592 42.0037 60.6549 42.1554C60.7177 42.307 60.75 42.4696 60.75 42.6337V55.1337H58.25V43.1513L52.3663 37.2676L54.1338 35.5Z",
    fill: "#322FB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup224);
export default __webpack_public_path__ + "static/media/Group 224.520c816b0a22d6e2d267d860f4d287d8.svg";
export { ForwardRef as ReactComponent };